"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectDebitPaymentPlanOutput = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var DirectDebitPaymentSchedule_1 = require("./DirectDebitPaymentSchedule");
var DirectDebitFunctions_1 = require("./DirectDebitFunctions");
var commonFunctions_1 = require("../../../../commonFunctions");
var DirectDebitPaymentPlanOutput = /** @class */ (function (_super) {
    __extends(DirectDebitPaymentPlanOutput, _super);
    function DirectDebitPaymentPlanOutput(props) {
        var _this = _super.call(this, props) || this;
        _this.renderContent = function () {
            var _a;
            return (React.createElement("div", { className: "mt-3" },
                React.createElement("div", { className: "mb-3" },
                    React.createElement(DirectDebitPaymentSchedule_1.default, { isOpen: _this.state.isOpen, instalments: _this.props.interaction.paymentDetails.instalmentPlan.instalments || [], isPaidOff: false, interaction: _this.props.interaction })),
                React.createElement("div", { className: "text-center" }, !((_a = _this.state) === null || _a === void 0 ? void 0 : _a.isOpen) ?
                    React.createElement("button", { className: "direct-debit-btn-text text-center cursor-pointer", onClick: _this.toggleInstallmentPlan },
                        "+ ",
                        React.createElement("span", { className: "text-decoration-underline" }, "View payment plan"))
                    :
                        React.createElement("button", { className: "direct-debit-btn-text text-center cursor-pointer", onClick: _this.toggleInstallmentPlan },
                            "- ",
                            React.createElement("span", { className: "text-decoration-underline" }, "Hide payment plan")))));
        };
        _this.toggleInstallmentPlan = function () {
            var _a;
            _this.setState({
                isOpen: !((_a = _this.state) === null || _a === void 0 ? void 0 : _a.isOpen)
            });
        };
        _this.state = {
            isOpen: false
        };
        return _this;
    }
    DirectDebitPaymentPlanOutput.prototype.render = function () {
        var interaction = this.props.interaction;
        var instalment = interaction.paymentDetails.instalmentPlan.instalments[0];
        var amount = instalment.principal + instalment.interest;
        var paymentDate = (0, DirectDebitFunctions_1.getFirstInstalmentDueDate)(interaction).format("Do MMMM YYYY");
        var monthlyRenewalDateUpdated = interaction.uistate.monthlyRenewalDateUpdated;
        return (React.createElement("div", { className: "text-left mt-4" },
            !monthlyRenewalDateUpdated && React.createElement("div", { className: "banner banner-info" },
                React.createElement("p", null,
                    "Your first instalment will be on ",
                    React.createElement("span", { className: "font-weight-bold" }, paymentDate),
                    " then on the same day of future months. If it\u2019s a weekend or bank holiday, payment will be taken on the next working day. You\u2019ll be able to change your payment day later in your account.")),
            monthlyRenewalDateUpdated && React.createElement("div", { className: "info-button-panel font-weight-light d-flex missing-registration-number banner" },
                React.createElement("img", { className: "d-block mx-3", src: "/Allianz/img/alert-grey-blue.svg", alt: "warning-sign" }),
                React.createElement("div", null,
                    "To set up your Direct Debit, we need to change your payment date. Your first instalment will be on ",
                    paymentDate,
                    " then on the same day of future months. If it\u2019s a weekend or bank holiday, payment will be taken on the next working day. You\u2019ll be able to change your payment day later in your account.")),
            React.createElement("p", null,
                "Below is a list of dates when we'll collect the payments (if your preferred payment date falls on a weekend or Bank Holiday, we'll take the payment on the next closest week day). You have ",
                this.props.interaction.paymentDetails.instalmentPlan.instalments.length,
                React.createElement("span", { className: "font-weight-semi-bold" },
                    " instalments of ",
                    (0, commonFunctions_1.getAmountToDisplay)(amount))),
            this.renderContent()));
    };
    return DirectDebitPaymentPlanOutput;
}(plugin_journey_1.WidgetBase));
exports.DirectDebitPaymentPlanOutput = DirectDebitPaymentPlanOutput;
//# sourceMappingURL=DirectDebitPaymentPlanOutput.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/directDebit/DirectDebitPaymentPlanOutput.js
// module id = 3703
// module chunks = 0